import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { useTheme } from "../../../../ui/src/contextProviders"
import { customStyle } from '@custom/Utils/utils';
import { useDrop } from 'react-dnd';
import { DropTargetMonitor } from 'react-dnd';

const stickyClasses = 'sticky top-0';
const notStickyClasses = 'relative';

const TopNavBar = ({ className, children, isSticky }) => {
  const { isDarkMode } = useTheme();

  const [{ isOver }, drop] = useDrop({
    accept: 'tools',
    drop: (item, monitor) => {
    },
    collect: (monitor: DropTargetMonitor) => ({
      isOver: monitor.isOver({ shallow: true }),
    }),
  });

  return (
    <div ref={drop}
      className={classnames(
        'bg-secondary-dark z-20 border-black px-1 pt-2 pb-2',
        isSticky && stickyClasses,
        !isSticky && notStickyClasses,
        className
      )}
      style={
        isDarkMode ? { background: '#041c4a' } : { background: '#75b1b1' }
      }
    >
      {children}
    </div>
  );
};

TopNavBar.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  isSticky: PropTypes.bool,
};

export default TopNavBar;
